.loading {
  width: min(100%, var(--measure-prose));
}

.skeleton {
  display: grid;
  gap: var(--space-3);
  padding: var(--space-5);
  border: 1px solid var(--line-subtle);
  background: var(--surface-raised);
}

.heading,
.line,
.shortLine {
  display: block;
  height: 0.75rem;
  background: var(--surface-inset);
  animation: loading-pulse 1.2s ease-in-out infinite alternate;
}

.heading {
  width: 38%;
  height: 1rem;
  margin-bottom: var(--space-2);
}

.shortLine {
  width: 64%;
}

@keyframes loading-pulse {
  from {
    opacity: 0.55;
  }

  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .heading,
  .line,
  .shortLine {
    animation: none;
  }
}
